import React, { useEffect } from "react";
import { Route, Switch, withRouter, BrowserRouter } from "react-router-dom";
import Login from "../components/Login/index";
import Privacy from "../components/Privacy";
import TermsServices from "../components/TermsServices";
import { getCookie } from "../utility/cookieProvider";
import { COOKIE } from "../constants/app-constant";
import Router from "./Router";
import {
  ROOT_ROUTE,
  PRIVACY_POLICIES,
  TERMS_AND_SERVICES,
  DASHBOARD_CONTAINER,
  FORGOT_PASSWORD,
  FEED_DETAILS,
  FEED_DETAILS_ALL,
} from "../constants/route-constants";
import NewsDetailsMain from "../components/NewsAndAnalysis/News/NewsDetailsMain";
import SocialFeedDetails from "../components/NewsAndAnalysis/News/Social/SocialFeedDetails";
import ForgotPassword from "../components/ForgotPassword";
import BlogsAndForumFeedDetails from "../components/NewsAndAnalysis/News/BlogAndForum/BlogsAndForumFeedDetails";
import { AccessDenied } from "../components/AccessDenied";
import { isOpenRoute } from "../utility/common-methods";

import 'rsuite/dist/rsuite.min.css';

const NON_SECURE_ROUTES = ["/", "/charts", "/forgot-password"];
const PUBLIC_URL = [PRIVACY_POLICIES, TERMS_AND_SERVICES];

const RouterComponent = ({ history, location, children }) => {
  useEffect(() => {
    if (location) {
      const path = location.pathname;
      const token = getCookie(COOKIE.AUTH_TOKEN);
      if (PUBLIC_URL.indexOf(path) === -1 || !isOpenRoute(path)) {
        if (
          !token &&
          NON_SECURE_ROUTES.indexOf(path) === -1 &&
          !renderNavbarForNewsDetainsPage()
        ) {
          history.push("/");
        } else if (token && NON_SECURE_ROUTES.indexOf(path) !== -1) {
          history.push(DASHBOARD_CONTAINER);
        }
      }
    }
  }, [history, location, renderNavbarForNewsDetainsPage]);

  const renderNavbarForNewsDetainsPage = () => {
    const locationSubString = location.pathname;
    return FEED_DETAILS_ALL.includes(locationSubString.slice(0, 7));
  };
  return <> {children}</>;
};

const WithRouterComponent = withRouter(RouterComponent);

export const Root = () => (
  <BrowserRouter>
    <Switch>
      <WithRouterComponent>
        <Route name="Login Page" exact path={ROOT_ROUTE} component={Login} />
        <Router />
        <Route
          name="Privacy Policy"
          path={PRIVACY_POLICIES}
          component={Privacy}
        />
        <Route
          name="Terms and Services"
          path={TERMS_AND_SERVICES}
          component={TermsServices}
        />
        <Route
          name="Forgot Password"
          exact
          path={FORGOT_PASSWORD}
          component={ForgotPassword}
        />
        <Route
          name="feed-details"
          exact
          path={`/mv/:mediaType/:articleIdentifier`}
          render={(props) => <NewsDetailsMain {...props} />}
        />
        <Route
          name="social-feed-details"
          exact
          path={`/mv/sad/:channel_type/:id`}
          render={(props) => <SocialFeedDetails {...props} />}
        />
        <Route
          name="social-feed-details"
          exact
          path={`/mv/bafad/:channel_type/:id`}
          render={(props) => <BlogsAndForumFeedDetails {...props} />}
        />
        <Route
          name="access-denied"
          exact
          path={`/access-denied`}
          render={() => <AccessDenied />}
        />
      </WithRouterComponent>
    </Switch>
  </BrowserRouter>
);
